import { combineReducers, createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';

import * as fromAnyObject from './any-object.reducer';

export const modelPortfoliosConfigGetters = {
	getInitialState(): ModelPortfoliosConfigState {
		return {
			modelPortfoliosConfig: fromAnyObject.initialState,
			selectedScenarioKeys: fromAnyObject.initialState,
			portfolioEditorVisible: fromAnyObject.initialState,
			uniqueIdForPortfolioEditor: fromAnyObject.initialState,
			blockDetailsCallAfterEdit: fromAnyObject.initialState
		};
	},
	getModelPortfoliosConfig(): MemoizedSelector<object, any> {
		return createSelector(getModelPortfoliosConfigState, fromAnyObject.getObject);
	},
	getSelectedScenarioKeys(): MemoizedSelector<object, any> {
		return createSelector(getSelectedScenarioKeysState, fromAnyObject.getObject);
	},
	getPortfolioEditorVisible(): MemoizedSelector<object, any> {
		return createSelector(getPortfolioEditorVisibleState, fromAnyObject.getObject);
	},
	getUniqueIdForPortfolioEditor(): MemoizedSelector<object, any> {
		return createSelector(getUniqueIdForPortfolioEditorState, fromAnyObject.getObject);
	},
	getBlockDetailsCallAfterEdit(): MemoizedSelector<object, any> {
		return createSelector(getBlockDetailsCallAfterEditState, fromAnyObject.getObject);
	}
};

export interface ModelPortfoliosConfigState {
	modelPortfoliosConfig: fromAnyObject.AnyObjectState;
	selectedScenarioKeys: fromAnyObject.AnyObjectState;
	portfolioEditorVisible: fromAnyObject.AnyObjectState;
	uniqueIdForPortfolioEditor: fromAnyObject.AnyObjectState;
	blockDetailsCallAfterEdit: fromAnyObject.AnyObjectState;
}

export function getInitialState(): ModelPortfoliosConfigState {
	return {
		modelPortfoliosConfig: fromAnyObject.initialState,
		selectedScenarioKeys: fromAnyObject.initialState,
		portfolioEditorVisible: fromAnyObject.initialState,
		uniqueIdForPortfolioEditor: fromAnyObject.initialState,
		blockDetailsCallAfterEdit: fromAnyObject.initialState
	};
}

export const ModelPortfoliosConfigStateNames = {
	modelPortfoliosConfig: 'modelPortfoliosConfig',
	selectedScenarioKeys: 'selectedScenarioKeys',
	portfolioEditorVisible: 'portfolioEditorVisible',
	uniqueIdForPortfolioEditor: 'uniqueIdForPortfolioEditor',
	blockDetailsCallAfterEdit: 'blockDetailsCallAfterEdit'
};

const reducers = combineReducers({
	modelPortfoliosConfig: fromAnyObject.createReducerWithName(ModelPortfoliosConfigStateNames.modelPortfoliosConfig),
	selectedScenarioKeys: fromAnyObject.createReducerWithName(ModelPortfoliosConfigStateNames.selectedScenarioKeys),
	portfolioEditorVisible: fromAnyObject.createReducerWithName(ModelPortfoliosConfigStateNames.portfolioEditorVisible),
	uniqueIdForPortfolioEditor: fromAnyObject.createReducerWithName(ModelPortfoliosConfigStateNames.uniqueIdForPortfolioEditor),
	blockDetailsCallAfterEdit: fromAnyObject.createReducerWithName(ModelPortfoliosConfigStateNames.blockDetailsCallAfterEdit)
});
export default reducers;

// get from state
export const getState = createFeatureSelector<ModelPortfoliosConfigState>('modelPortfoliosConfig');


export const getModelPortfoliosConfigState = createSelector(getState, state => state.modelPortfoliosConfig);

export const getSelectedScenarioKeysState = createSelector(getState, state => state.selectedScenarioKeys);

export const getPortfolioEditorVisibleState = createSelector(getState, state => state.portfolioEditorVisible);

export const getUniqueIdForPortfolioEditorState = createSelector(getState, state => state.uniqueIdForPortfolioEditor);

export const getBlockDetailsCallAfterEditState = createSelector(getState, state => state.blockDetailsCallAfterEdit);
